<!-- No users message -->
<div class="flex-row align-items-center justify-content-center" style="margin: 0 auto; padding: 48px"
  *ngIf="noUsers && !loading">
  {{ 'placeholder.no_users' | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div class="table-wrapper" [class.loading]="loading" [style.min-height.px]="containerHeight" *ngIf="!noUsers">
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table mat-table [dataSource]="items" class="spotlab-table" matSort [class.dimmed]="loading" style="width: 100%">
    <ng-container matColumnDef="avatar">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <ts-user-avatar [user]="item"></ts-user-avatar>
      </td>
    </ng-container>

    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.username' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item" class="username-cell">
        <span class="username-text">{{ item.username }}</span>
        <i class="ri-mail-line username-icon" *ngIf="!item.emailVerified"
          [matTooltip]="'info.email_not_verified' | translate"></i>
      </td>
    </ng-container>

    <ng-container matColumnDef="affiliateSince">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.start' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        <span>{{ item.affiliationDate | date : 'short' | uppercase }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.roles' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        <span class="text-secondary" *ngIf="!item.roles">
          {{ 'info.retrieving_information' | translate }}
        </span>
        <ts-role-badge *ngFor="let role of item.roles" [role]="role.name">
          {{ role.name | translate | uppercase }}
        </ts-role-badge>
      </td>
    </ng-container>

    <ng-container matColumnDef="workspaces">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'title.workspaces' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        <ts-loading-attribute icon="ri-file-copy-2-line" [value]="item.numWorkspaces" class="text-gray"
          [tooltip]="'tooltip.users.numWorkspaces' | translate"></ts-loading-attribute>
      </td>
    </ng-container>

    <ng-container matColumnDef="member">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'table.users.columns.is_member' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let item">
        <button *ngIf="item.isMemberOfWorkspace === true" class="icon-button" type="button"
          (click)="onMembershipToggle(item); $event.stopPropagation()">
          <mat-icon class="text-primary">check_circle</mat-icon>
        </button>
        <button *ngIf="item.isMemberOfWorkspace === false" class="icon-button" type="button"
          (click)="onMembershipToggle(item); $event.stopPropagation()">
          <mat-icon class="text-gray">add_circle</mat-icon>
        </button>
        <mat-spinner *ngIf="item.isMemberOfWorkspace === undefined" class="icon-button" diameter="20"></mat-spinner>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item" class="icon-cell">
        <button class="icon-button" type="button" (click)="editItem.emit(item); $event.stopPropagation()"
          data-cy="user-edit">
          <i class="ri-pencil-line"></i>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item" class="icon-cell">
        <button class="icon-button danger" type="button" (click)="itemRemoved.emit(item); $event.stopPropagation()"
          data-cy="user-delete">
          <i class="ri-delete-bin-6-line"></i>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
    <tr mat-row *matRowDef="let item; columns: visibleColumns" [class.hoverable-row]="true"></tr>
  </table>
</div>
